import type { RouteRecordRaw } from 'vue-router'

import { AppRoute } from '@/constants'
import { Administration } from '@/constants/rights'

export const SettingsRoutes: RouteRecordRaw[] = [
  {
    path: AppRoute.Settings.path,
    name: AppRoute.Settings.name,
    component: () => import('@/modules/settings/Index.vue'),
    meta: {
      requiresAuth: true,
      authorities: [Administration],
    },
  },
]
